import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    userInfo: null,
    carList: [],
    token: '',
    ticketPayData: null,
    channel: '',
    scottCarParam: {},
    ticketConfig: null,
    AiTicketList: [],
    coupondata: null,
    couponId: '',
    orderModify: {},
  },
  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-token', token);
      } catch (e) {
        console.log(e);
      }
    },
    SET_ORDER_MODIFY(state, orderModify) {
      state.orderModify = orderModify;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-orderModify',  JSON.stringify(orderModify));
      } catch (e) {
        console.log(e);
      }
    },
    SET_CHANNEL(state, channel) {
      state.channel = channel;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-channel', channel);
      } catch (e) {
        console.log(e);
      }
    },
    SET_SCOTT_CAR_PARAM(state, scottCarParam) {
      state.scottCarParam = scottCarParam;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-scottCarParam', scottCarParam);
      } catch (e) {
        console.log(e);
      }
    },
    SET_USERINFO(state, userInfo) {
      state.userInfo = userInfo;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-userInfo', JSON.stringify(userInfo));
      } catch (e) {
        console.log(e);
      }
    },
    SET_AITICKETLIST(state, AiTicketList) {
      state.AiTicketList = AiTicketList;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-AiTicketList', AiTicketList);
      } catch (e) {
        console.log(e);
      }
    },
    SET_TICKETCONFIG(state, ticketConfig) {
      state.ticketConfig = ticketConfig;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-ticketConfig', ticketConfig);
      } catch (e) {
        console.log(e);
      }
    },
    SET_CARLIST(state, carList) {
      state.carList = carList;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-carList', JSON.stringify(carList));
      } catch (e) {
        console.log(e);
      }
    },
    SET_TICKETPAYDATA(state, ticketPayData) {
      state.ticketPayData = ticketPayData;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-ticketPayData', JSON.stringify(ticketPayData));
      } catch (e) {
        console.log(e);
      }
    },
    SET_ILLEGALPAYDATA(state, illegalPayData) {
      state.illegalPayData = illegalPayData;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-illegalPayData', JSON.stringify(illegalPayData));
      } catch (e) {
        console.log(e);
      }
    },
    SET_COUPONDATA(state, coupondata) {
      state.coupondata = coupondata;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-coupondata', JSON.stringify(coupondata));
      } catch (e) {
        console.log(e);
      }
    },
    SET_COUPONDID(state, couponId) {
      state.couponId = couponId;//eslint-disable-line
      try {
        window.localStorage.setItem('s4s-vio-couponId', JSON.stringify(couponId));
      } catch (e) {
        console.log(e);
      }
    },
  },
  actions: {
    getCar({ commit, state, getters }, refresh) {
      if (refresh) {
        commit('SET_CARLIST', []);
      }
      // if (state.carList.length) {
      //   return state.carList;
      // }
      // if (getters.carList.length) {
      //   state.carList = getters.carList;//eslint-disable-line
      //   return getters.carList;
      // }
      return new Promise((getCarResolve) => {
        Vue.prototype.$request('v3/violation/car/list').then((xhr, res) => {
          if (res.code === 0 && res.data && res.data.length > 0) {
            const carList = res.data.map(item => ({
              proviceCarno: item.CarNo || '',
              vin: item.ClassNo || '',
              engion: item.EngineNo || '',
              carType: item.CarType || '',
              registe_time: item.RegisterCardTime || '',
            }));
            commit('SET_CARLIST', carList.reverse());
          } else {
            commit('SET_CARLIST', []);
          }
          getCarResolve('true');
        }).catch((e) => {
          console.log(e);
        });
      });
    },
    login({ commit }) {
      commit('SET_USERINFO');
    },
  },
  getters: {
    userInfo: (state) => {
      if (!state.userInfo) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-userInfo') || 'null';
        } catch (e) {
          console.log(e);
        }
        const data = JSON.parse(json);
        state.userInfo = data;//eslint-disable-line
        return data;
      }
      return state.userInfo;
    },
    AiTicketList: (state) => {
      if (!state.AiTicketList) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-AiTicketList') || [];
        } catch (e) {
          console.log(e);
        }
        const data = JSON.parse(json);
        state.AiTicketList = data;//eslint-disable-line
        return data;
      }
      return state.AiTicketList;
    },
    ticketConfig: (state) => {
      if (!state.ticketConfig) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-ticketConfig') || null;
        } catch (e) {
          console.log(e);
        }
        const data = JSON.parse(json);
        state.ticketConfig = data;//eslint-disable-line
        return data;
      }
      return state.ticketConfig;
    },
    token: (state) => {
      if (!state.token) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-token') || null;
        } catch (e) {
          console.log(e);
        }
        const data = json;
        state.token = data;//eslint-disable-line
        return data;
      }
      return state.token;
    },
    channel: (state) => {
      if (!state.channel) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-channel') || null;
        } catch (e) {
          console.log(e);
        }
        const data = json;
        state.channel = data;//eslint-disable-line
        return data;
      }
      return state.channel;
    },
    scottCarParam: (state) => {
      if (!state.scottCarParam) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-scottCarParam') || null;
        } catch (e) {
          console.log(e);
        }
        const data = json;
        state.scottCarParam = data;//eslint-disable-line
        return data;
      }
      return state.scottCarParam;
    },
    orderModify: (state) => {
      if (!state.orderModify) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-orderModify') || '{}';
        } catch (e) {
          console.log(e);
        }
        const data = JSON.parse(json);
        state.orderModify = data;//eslint-disable-line
        return data;
      }
      return state.orderModify;
    },
    carList: (state) => {
      if (!state.carList.length) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-carList') || '[]';
        } catch (e) {
          console.log(e);
        }
        const data = JSON.parse(json);
        if (Array.isArray(data)) {
          state.carList = data;//eslint-disable-line
          return data;
        }
      }
      return state.carList;
    },
    ticketPayData(state) {
      if (!state.ticketPayData) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-ticketPayData') || '{}';
        } catch (e) {
          console.log(e);
        }
        const data = JSON.parse(json);
        state.ticketPayData = data;//eslint-disable-line
        return data;
      }
      return state.ticketPayData;
    },
    illegalPayData(state) {
      if (!state.illegalPayData) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-illegalPayData') || '{}';
        } catch (e) {
          console.log(e);
        }
        const data = JSON.parse(json);
        state.illegalPayData = data;//eslint-disable-line
        return data;
      }
      return state.illegalPayData;
    },
    coupondata(state) {
      if (!state.coupondata) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-coupondata') || '{}';
        } catch (e) {
          console.log(e);
        }
        const data = JSON.parse(json);
        state.coupondata = data;//eslint-disable-line
        return data;
      }
      return state.coupondata;
    },
    couponId(state) {
      if (!state.couponId) {
        let json;
        try {
          json = window.localStorage.getItem('s4s-vio-couponId') || null;
        } catch (e) {
          console.log(e);
        }
        const data = JSON.parse(json);
        state.couponId = data;//eslint-disable-line
        return data;
      }
      return state.couponId;
    },
  },
});
